import DefaultApiService from "./default.js";

const unwrap = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (!isSuccess) {
    return {
      error: res?.message || res?.Message || fallbackMessage,
      data: null,
    };
  }
  return { error: null, data: res?.data ?? res?.Data ?? null };
};

const ContractorReferralAdminApi = {
  getAttributions: (params) =>
    DefaultApiService.getApi("SLN/Management/ContractorReferralLeads/GetAttributions", params),

  getContractorOptions: () =>
    DefaultApiService.getApi("SLN/Management/ContractorReferralLeads/GetContractorOptions"),

  normalizeAttributions: (res) =>
    unwrap(res, "بارگذاری گزارش معرفی پیمانکاران ناموفق بود."),

  normalizeContractors: (res) =>
    unwrap(res, "بارگذاری لیست پیمانکاران ناموفق بود."),
};

export default ContractorReferralAdminApi;
